export default {"src":"/_next/static/media/link.803da7a8.svg","height":132,"width":132,"blurWidth":0,"blurHeight":0};